export const pallet = (
  <>
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6L15.5 12"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 4.5L19 11"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 7L14 14"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.75 3L1 8.75V9.25L10.75 15.5H11.25L21 9.25V8.75L11.25 3H10.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 9.5V13L11 19.5L21 13V9.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 16V19"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
);
